<template>
  <div class="phoneFindpwPage" :style="{height: scrollerHeight}">
    <Header></Header>
    <!-- banner -->
    <div class="findBox">
      <ul>
        <li>
          <div></div>
           <span class="txt" @click="goPhoneFind">{{$t('productIndex.findPhone')}}</span>
           <img src="../../../assets/picture/product/more.png">
        </li>
        <li>
          <div></div>
           <span class="txt" @click="goEmailFind">{{$t('productIndex.findEmail')}}</span>
           <img src="../../../assets/picture/product/more.png">
        </li>
      </ul>
    </div>
    <!-- footer -->
    <div class="footerBox phoneShow">
        <div class="container">
          <p>&copy;{{copyright}}</p>
          <p>(<a target="_blank" href="http://beian.miit.gov.cn/">{{icpNumber}}</a>）</p>
        </div>
    </div>
  </div>
</template>

<script>
import Header from '../../common/header';
// import Footer from '../common/footer';
export default {
  data() {
    return {
      isShowSearch:false,
      fullHeight: '',
      width:0,
      height:0,
      scrollerHeight:'',
    };
  },
  components: { Header},
  mounted(){
      this.scrollerHeight = (window.innerHeight-60) + 'px';
  },
  methods: {
    showSearch(){
      this.isShowSearch = !this.isShowSearch;
    },
    goPhoneFind(){
      this.$router.push({  
            path: '/phoneFind',       
        })
    },
    goEmailFind(){
      this.$router.push({  
            path: '/emailFind',       
        })
    }
  }
};
</script>

<style lang="less" scoped>
.phoneFindpwPage{
  width: 100%;
  height: 100%;
  .findBox{
    width: 100%;
    padding-top: 10rem;
    position: relative;
    background:#F2F2F2;
    height: 100%;
    ul{
      display: block;
      margin:0 auto;
      width: 80%;
      position: absolute;
      top:20%;
      left:50%;
      margin-left: -40%;
      li:nth-of-type(1){
        margin-bottom:5rem;
      };
     li{
        width: 100%;
        padding:12.6rem 0;
        cursor: pointer;   
        background-image: url(../../../assets/picture/product/findBox.png);
        background-repeat:no-repeat;  
        background-size: cover;
        display: flex;
        }
        img{
          width: 2.2rem;
          height: 2.2rem;
          display: block;
          margin-top: 2.3rem;
          margin-left: 2rem;
        }
        .txt{
            display: block;
            color: #fff;
            font-size: 4.4rem;
            margin-left: 5.2rem;
            letter-spacing: 4px;
            font-weight: 100;
        }
    }
  }
.footerBox{
  width: 100%;
  background: #1E1E1E;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #F2F2F2;
  line-height: 20px;
  padding:20px 18px;
  position: fixed;
  bottom: 0;
  a,a:hover{
    font-weight: 500;
    color: #F2F2F2;
  }
}
}
</style>
